import { Component, ElementRef, EventEmitter, forwardRef, Input, Output } from "@angular/core";
import { ControlComponent } from "../../control.component";
import { FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { ITextareaFieldValue, TextareaControl } from "../textarea-control.model";

@Component({
    selector: "vas-textarea",
    template: `
        <ion-textarea [formControl]="textAreaFormGroup.get('value')" maxlength="255"></ion-textarea>
    `,
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TextareaControlComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => TextareaControlComponent), multi: true}
    ]
})
export class TextareaControlComponent extends ControlComponent {
    @Input() definition: TextareaControl;
    @Output() changes: EventEmitter<any> = new EventEmitter();

    textAreaFormGroup = new FormGroup({
        value: new FormControl()
    });

    constructor(
        protected elemRef: ElementRef
    ) {
        super(elemRef);
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.textAreaFormGroup.get("value").valueChanges
            .takeUntil(this.ngUnsubscribe)
            .subscribe(value => this.updateValue(value));
    }

    writeValue(value: ITextareaFieldValue): void {
        this.textAreaFormGroup.get("value").setValue(value);
        this.textAreaFormGroup.get("value").markAsPristine();
    }

    updateValue(value: ITextareaFieldValue): void {
        super.updateValue(value);
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/textarea/form/textarea-control.component.ts